const app = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default app;
